import { yupResolver } from '@hookform/resolvers/yup';
import { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { $http } from '../../../../plugins';
import { CabinetContext } from '../../context';
import { SET_STEP, SET_TOKEN } from '../../context/types';

export default () => {
  const {
    dispatch,
    state: { form, step }
  } = useContext(CabinetContext);
  const {
    register,
    handleSubmit,
    control,
    setValue,
    setError,
    formState: { errors }
  } = useForm({ mode: 'onBlur', resolver: yupResolver(schema) });
  const [loading, setLoading] = useState(false);

  const onSubmit = handleSubmit(async (data) => {
    setLoading(true);
    try {
      const res = await $http.post('Security/User/Session/Login', {
        ...data,
        platform: 'Website',
        osName: 'string',
        device: 'string'
      });
      localStorage.setItem('token', res.data.session.token);
      localStorage.setItem('refreshToken', res.data.session.refreshToken);
      dispatch({ type: SET_TOKEN, payload: res.data.session.token });
      dispatch({ type: SET_STEP, payload: step + 1 });
    } finally {
      setLoading(false);
    }
  });

  return { register, control, errors, onSubmit, form, setValue, loading };
};

const schema = yup.object({
  username: yup.string().required(' اقل عدد احرف 5 الحقل مطلوب').min(5),
  password: yup.string().required(' اقل عدد احرف 5 الحقل مطلوب').min(5)
});
